import { call, select } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  set as setCard
} from '../redux/cards'

export default function * requestChangeCardStartDate (action) {
  const { id, startDate } = action.payload

  const state = yield select()

  const vCard = state['view-myboard'].cards[id]
  
  if (!vCard) return

  const optimisticAction = yield optimisticPut(setCard({
    id,
    data: {
      startDate
    }
  }))

  try {
    yield call(apiAction, 'SetStartDate', {
      cardId: vCard.cardId,
      timestamp: startDate
    })

    yield optimisticAction.commit()
  } catch (error) {
    yield optimisticAction.revert()

    throw error
  }
}
